import { createContext, useContext, useMemo, type ReactNode } from "react";
import { resolveTenantFromHost, type TenantContext } from "@crucible/tenant";

const TenantCtx = createContext<TenantContext | null>(null);

export function TenantProvider({ children }: { children: ReactNode }) {
  const value = useMemo(
    () => resolveTenantFromHost(window.location.hostname),
    [],
  );

  return <TenantCtx.Provider value={value}>{children}</TenantCtx.Provider>;
}

export function useTenant() {
  const ctx = useContext(TenantCtx);
  if (!ctx) throw new Error("useTenant must be used within TenantProvider");
  return ctx;
}